<template><div><h1>手动配置使用</h1>
<p><a href="https://github.com/airyland/vux/tree/v2/packages/vue-cli-3-example">https://github.com/airyland/vux/tree/v2/packages/vue-cli-3-example</a></p>
<div class="tip">
<p>注意的是下面事项并非表示 VUX 使用繁琐，部分只是出于确保有正确的依赖和配置，而部分是出于优化。</p>
</div>
<div class="warning">
<p>请将 <code>babel-loader</code> 的配置写到 <code>.babelrc</code> 里而不是使用 <code>options</code>，否则可能会出错。</p>
</div>
<p>折腾能力强的同学参考一下，下面即<code>airyland/vux2</code>模板主要处理的事项:</p>
<ul>
<li>
<p>引入 <code>reset.less</code>，默认样式不包含reset，并且部分用户自己有一套reset样式，因此需要在<code>App.vue</code>进行手动引入</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">style</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"less"</span>&gt;</span><span class="undefined">
@import '~vux/src/styles/reset.less';
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
</code></pre>
</li>
<li>
<p>配置 <code>vue-loader</code>（通过配置vux-loader实现）</p>
<pre class="hljs"><code><span class="hljs-comment">// vux-loader</span>
<span class="hljs-built_in">module</span>.exports = {
  <span class="hljs-attr">configureWebpack</span>: <span class="hljs-function"><span class="hljs-params">config</span> =&gt;</span> {
    <span class="hljs-built_in">require</span>(<span class="hljs-string">'@vux/loader'</span>).merge(config, {
        <span class="hljs-attr">plugins</span>: [<span class="hljs-string">'vux-ui'</span>, {
          <span class="hljs-attr">name</span>: <span class="hljs-string">'less-theme'</span>,
          <span class="hljs-attr">path</span>: <span class="hljs-string">'src/theme.less'</span>
        }]
    })
  }
}
</code></pre>
</li>
<li>
<p>配置<code>babel-loader</code>以正确编译 VUX 的js源码（通过配置vux-loader实现）</p>
<pre class="hljs"><code><span class="hljs-built_in">module</span>.exports = {
  <span class="hljs-attr">configureWebpack</span>: <span class="hljs-function"><span class="hljs-params">config</span> =&gt;</span> {
    <span class="hljs-built_in">require</span>(<span class="hljs-string">'@vux/loader'</span>).merge(config, {
        <span class="hljs-attr">plugins</span>: [<span class="hljs-string">'vux-ui'</span>, {
          <span class="hljs-attr">name</span>: <span class="hljs-string">'less-theme'</span>,
          <span class="hljs-attr">path</span>: <span class="hljs-string">'src/theme.less'</span>
        }]
    })
  }
}
</code></pre>
</li>
<li>
<p>安装<code>less-loader</code>以正确编译less源码</p>
<pre class="hljs"><code>npm install less less-loader --save-dev
</code></pre>
</li>
<li>
<p>安装 <code>yaml-loader</code> 以正确进行语言文件读取</p>
<pre class="hljs"><code>npm install yaml-loader --save-dev
</code></pre>
</li>
<li>
<p>添加 <code>viewport</code> meta</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">meta</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"viewport"</span> <span class="hljs-attr">content</span>=<span class="hljs-string">"width=device-width,initial-scale=1,user-scalable=0"</span>&gt;</span>
</code></pre>
</li>
<li>
<p>添加 <code>Fastclick</code> 移除移动端点击延迟</p>
<pre class="hljs"><code><span class="hljs-keyword">const</span> FastClick = <span class="hljs-built_in">require</span>(<span class="hljs-string">'fastclick'</span>)
FastClick.attach(<span class="hljs-built_in">document</span>.body)
</code></pre>
</li>
<li>
<p>添加 <code>vue-router</code>（如果不需要前端路由，可忽略）</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> VueRouter <span class="hljs-keyword">from</span> <span class="hljs-string">'vue-router'</span>
Vue.use(VueRouter)
</code></pre>
</li>
<li>
<p>添加 webpack plugin, 在构建后去除重复css代码（通过配置vux-loader实现）</p>
<pre class="hljs"><code>plugins: [{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'duplicate-style'</span>
}]
</code></pre>
</li>
<li>
<p>如果你使用 <code>webpack-simple</code> 模板或者 webpack 配置里缺少 .vue extension 配置，请记得配置：</p>
<pre class="hljs"><code>resolve: {
  <span class="hljs-attr">extensions</span>: [<span class="hljs-string">'.js'</span>, <span class="hljs-string">'.vue'</span>, <span class="hljs-string">'.json'</span>]
</code></pre>
</li>
</ul>
</div></template><script>
export default {
  head: {"title":"VUX 手动配置使用 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// manual-usage-167.vue?7f50441c